module.exports = __webpack_public_path__ + "img/1.087ce782.png";